import { useSearch } from "@tanstack/react-router";
import { useContext } from "react";
import { cn } from "tailwind-variants";
import { useGetSearchSettings } from "#/app/features/search/hooks/useGetSearchSettings.ts";
import { SearchServerStateContext } from "#/app/features/search/search-server-state";
import { m } from "#/paraglide/messages";
import { SearchExperience } from "./search-experience";

export function SearchResults({
	className,
	isPreview = false,
	showContentTagFilter = true,
	contained = true,
}: {
	className?: string;
	isPreview?: boolean;
	showContentTagFilter?: boolean;
	contained?: boolean;
}) {
	if (isPreview)
		return (
			<div className={cn(contained && "container", "mb-8", className)}>
				<div className="search-page">
					<div className="search-page-form">
						<label htmlFor="search-results-preview">{m.search()}</label>
						<input
							id="search-results-preview"
							className="form-control form-control-search"
							type="search"
							placeholder={m.search_placeholder()}
							disabled
						/>
						<p>S&ouml;kresultaten visas p&aring; webbplatsen.</p>
					</div>
				</div>
			</div>
		);
	return (
		<LiveSearchResults
			className={className}
			showContentTagFilter={showContentTagFilter}
			contained={contained}
		/>
	);
}

function LiveSearchResults({
	className,
	showContentTagFilter,
	contained,
}: {
	className?: string;
	showContentTagFilter: boolean;
	contained: boolean;
}) {
	const settings = useGetSearchSettings();
	const search = useSearch({ strict: false });
	const query = typeof search.q === "string" ? search.q : "";
	const initial = useContext(SearchServerStateContext);
	const serverState =
		initial?.query === query && initial.indexName === settings.indexName
			? initial.state
			: undefined;
	return (
		<SearchExperience
			key={`${settings.indexName}:${query}`}
			settings={settings}
			query={query}
			className={className}
			serverState={serverState}
			showContentTagFilter={showContentTagFilter}
			contained={contained}
		/>
	);
}
